export const sendCustomEvent = <T>(eventName: string, detail: T) => {
  const event = new CustomEvent<T>(eventName, { detail })
  window.dispatchEvent(event)
}
